export enum CallTargetType {
	Sip,
	Bussiness,
	Mobile,
}

export enum CustomerHistoryMediaType {
	Call = 0,
	Email = 1,
	Voicemail = 2,
	WrapUp = 3,
	WhatsApp = 4,
	Webchat = 5,
}
